import { PaginaNode } from '@gql/graphql'
import { useTrans } from 'hooks'
import { extractSubtitleDescription } from '@utils/index'
import { PlaceholderReact } from '@components/molecules'
import { CardSwiper, GenericHero, Page, Prefooter } from 'components/organisms'
import styles from './AziendaDetailTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
  paginaAzienda?: PaginaNode
}

const AziendaDetailTemplate = (props: Props) => {
  const { pagina = undefined, paginaAzienda = undefined } = props

  const t = useTrans()

  const defaultContent1 = pagina?.pagebuilders?.find((x) => x.key === 'main') ?? null

  const correlatiItem = {
    name: t("L'azienda"),
    ctaLabel: t('Scopri di più sull’Azienda'),
    url: paginaAzienda?.url,
    children: paginaAzienda?.menuChildren
      ? paginaAzienda.menuChildren
          .filter((x) => x.chiave !== pagina.chiave)
          .map((x) => ({ name: x.nome, image: x.previewImage, url: x.url }))
      : [],
  }

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero pagina={pagina} />
        <div className={styles.placeholderContent}>
          <PlaceholderReact
            contentTypeId={pagina.model}
            objectId={pagina.pk}
            pkey={'main'}
            serverSideContent={defaultContent1}
          />
        </div>
        <CardSwiper id="azienda-detail-correlati-swiper" item={correlatiItem} size={'md'} />
        <Prefooter />
      </main>
    </Page>
  )
}

export default AziendaDetailTemplate
